import z from "zod";
import { PaginationParamsDTO, SortParamsDTO } from "./base";

export const GetCandidatesFilterDTO = z.object({
  keywords: z.string().optional(),
  batchIds: z.coerce.number().array().optional(),
  courseId: z.coerce.number().nullable().optional(),
  pincodes: z.string().array().optional(),
  genders: z.enum(["male", "female"]).array().optional(),
  vleIds: z.coerce.bigint().array().optional(),
  stateIds: z.coerce.bigint().array().optional(),
  transactionNumbers: z.coerce.bigint().array().optional(),
  districtIds: z.coerce.bigint().array().optional(),
  highestQualifications: z
    .enum(["q_10", "q_12", "q_graduate", "q_post_graduate"])
    .array()
    .optional(),
  identityProofTypes: z
    .enum(["driving_license", "employers_card", "pan", "passport"])
    .array()
    .optional(),
  registrationStartDate: z.coerce.date().optional(),
  registrationEndDate: z.coerce.date().optional(),
});

export const GetCandidatesRequestInputDTO = z.object({
  filter: GetCandidatesFilterDTO,
  paginationParams: PaginationParamsDTO,
  sort: SortParamsDTO(
    z.enum([
      "createdAt",
      "name",
      "email",
      "mobileNumber",
      "gender",
      "highestQualification",
      "identityProofType",
      "identityProofNumber",
      "vleName",
      "vleId",
      "stateName",
      "districtName",
      "transactionNumber",
    ])
  ),
});
